export default {
  'hero.support': 'Hơn 200 Tour được thiết kế riêng',
  'hero.title': 'Luôn đồng hành cùng bạn trên hành trình\nkhám phá Tổ Quốc thân yêu',
  'hero.subtitle': 'Am hiểu địa phương - Chúng tôi cam kết mang đến những câu chuyện thú vị cho chuyến đi khám phá Việt Nam của bạn và người thương',
  'hero.exploreTours': 'Khám phá tour',
  'hero.whereNext': 'Bạn muốn đến đâu?',
  'hero.alt': 'Du lịch Việt Nam',
  'tourPackages.title': 'Tour Trọn Gói',
  'tourPackages.durationAll': 'Hành trình: Tất cả',
  'tourPackages.days1to3': '1-3 ngày',
  'tourPackages.days4to7': '4-7 ngày',
  'tourPackages.days8plus': '8+ ngày',
  'tourPackages.viewAll': 'Xem tất cả',
  'tourPackages.empty': 'Chưa có tour nào. Hãy quay lại sau nhé!',
  'tourPackages.spots': '{{count}} điểm',
  'tourPackages.from': 'TỪ',
  'tourPackages.view': 'Xem',
  'experiences.empty': 'Chưa có trải nghiệm nào ở khu vực này.',
  'experiences.from': 'TỪ {{price}} USD',
  'home.northernExperiences': 'Miền Bắc Mờ Sương',
  'home.centralExperiences': 'Miền Trung Di Sản',
  'home.southernExperiences': 'Miền Nam Miệt Vườn',
  'search.placeholder': 'Tìm kiếm điểm đến mơ ước...',
  'search.button': 'Tìm kiếm',
  'search.clear': 'Xóa tìm kiếm',
  'search.error': 'Không thể tải điểm đến.',
  'search.noResult': 'Không tìm thấy điểm đến cho "{{query}}"',
  'channel.title': 'Kênh của chúng tôi',
  'channel.team': 'Đội ngũ của chúng tôi',
  'channel.guide': 'Hướng dẫn viên',
  'channel.internet': 'Internet vs. Chuyên gia địa phương',
  'channel.expert': 'Lựa chọn của chuyên gia',
  'channel.essentials': 'Đồ dùng cần thiết khi du lịch',
  'reviews.howEarn': 'Khách hàng đánh giá',
  'reviews.star': '4.9 SAO',
  'reviews.on': 'TRÊN',
  'reviews.empty': 'Chưa có đánh giá nào.',
  'reviews.showLess': 'Thu gọn',
  'reviews.readMore': 'Đọc thêm',
  'reviews.postedOn': 'Đăng trên Tripadvisor',
  'experience.breadcrumb': 'Điều hướng',
  'experience.notFound': 'Không tìm thấy trải nghiệm',
  'experience.backHome': 'Về trang chủ',
  'experience.home': 'Trang chủ',
  'experience.experiences': 'Trải nghiệm',
  'experience.ctaTitle': 'Muốn đặt trải nghiệm này?',
  'experience.ctaText': 'Hãy cho chúng tôi biết ngày đi và sở thích của bạn, chuyên gia địa phương sẽ phản hồi với một kế hoạch được thiết kế riêng. Chưa có gì được đặt hay tính phí ở giai đoạn này.',
  'experience.contactExpert': 'Liên hệ chuyên gia địa phương',
  'experience.priceFrom': 'Giá tham khảo từ',
  'experience.category': 'Danh mục',
  'experience.travelStyle': 'Phong cách du lịch',
  'experience.region': 'Khu vực',
  'experience.enquire': 'Gửi yêu cầu',
  'experience.regionNorthern': 'Miền Bắc Việt Nam',
  'experience.regionCentral': 'Miền Trung Việt Nam',
  'experience.regionSouthern': 'Miền Nam Việt Nam',
};